import { TFunc } from '@Translations';
import * as yup from 'yup';

export const SensorTestSchema = (t: TFunc) => {
	const schema = {
		sensorId: yup.string().when('tagValue', {
			is: (tagValue: string) => !tagValue?.length,
			then: yup
				.string()
				.required(
					t('Sensor ID is required because tag is not defined'),
				),
		}),
		dataSourceId: yup.string().required(t('Data Source is required')),
		sensorIdField: yup.string().required(t('Sensor ID Field is required')),
		sensorTable: yup.string().required(t('Sensor Table Field is required')),
		sensorDateField: yup
			.string()
			.required(t('Sensor Date Field is required')),
		sensorChannelField: yup
			.string()
			.required(t('Sensor Channel Field is required')),
		tagValue: yup
			.string()
			.when('dataSourceType', {
				is: 'OPC-UA',
				then: yup
					.string()
					.required(t('Node ID is required.'))
					.matches(
						/^.*ns=.*$/,
						t(
							'Node ID must be in OPC-UA Node ID format (ns=xxxx).',
						),
					),
			})
			.when('sensorId', {
				is: (sensorId: string) => !sensorId?.length,
				then: yup
					.string()
					.required(
						t(
							'Tag Value Field is required because sensor id is not defined',
						),
					),
			}),
	};

	return yup.object().shape(schema, [['sensorId', 'tagValue']]);
};
